import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { CustomerBill, CustomerBillService, CustomerBillFilter, CustomerBillData, CustomerBillId } from '../../services/customer-bill.service';
import { CustomerSupplierId, CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { IncomedBill, Income, IncomeService, IncomeData } from '../../services/income.service';

import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Utils } from '../../util';
import { Pdf } from '../../coms';
import { PdfTemplates } from '../../pdfTemplates';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { Globals } from '../../globals';

@Component({
  selector: 'app-read-customer-bill',
  templateUrl: './read-customer-bill.component.html',
  styleUrls: ['./read-customer-bill.component.css']
})
export class ReadCustomerBillComponent implements OnInit, OnDestroy {
  loaded: boolean = true;
  allowed: boolean = false;
  permission: any = {};

  customerBills:any[] = [];

  customerId: string = '';
  customers: CustomerSupplierId[] = [];

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Folio', name: 'name'},
    {title: 'Cliente', name: 'customerName'},
    {title: 'Fecha', name: 'date'},
    {title: 'Fecha Recepción', name: 'receptionDate'},
    {title: 'Fecha Pago', name: 'payDate'},
    {title: 'Estatus', name: 'statusName'},
    {title: 'UUID', name: 'uuid'},
    {title: 'Total', name: 'money_total', className: 'tdRight thCenter'},
    {title: 'Saldo', name: 'money_residue', className: 'tdRight thCenter'},
    {title: 'Moneda', name: 'currency'},
    { title: 'Acciones', className: 'center minTwoButtons',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'show', title: '', styleIcon: 'open_with', action: 'onShow',
				styleClass: 'btn-floating btn waves-effect light-blue darken-1' },
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			/* { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', } */
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
      onShow: this.onShow.bind(this),
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  receivedAll: boolean = false;

  constructor(
    private service: CustomerBillService,
    private billData: CustomerBillData,
    private customerService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private incomeService: IncomeService,
    private incomeData: IncomeData,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private fsService: FirestoreService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.subs[4] = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
    });
		/* this.subs[3] = this.service.getCustomerBillsFifteenDays().subscribe(tempCustomerBills => {
      //this.subs[3].unsubscribe();
			this.customerBills = tempCustomerBills.map(({cfdi:{currency='key0'}={}, status='key0', ...customerBill}) => {
        this.incomedBills[customerBill.id] = new IncomedBill({...customerBill});
        customerBill.name = customerBill.folio;
        customerBill.receptionDate = customerBill.receptionDate || '';
        customerBill.statusName = this.billData.status[status];
        customerBill.uuid = customerBill.uuid || 'N.A.'
        customerBill.customerName = customerBill.customerObj.name;
        customerBill.residue = this.incomedBills[customerBill.id].residue;
        customerBill.money_residue = this.money(customerBill.residue);
        customerBill.money_total = this.money(customerBill.totals.total);
        customerBill.currency = this.billData.currencySelect[currency].code;
        return customerBill;
      }).sort(({folio}, {folio: folio2}) => folio2 - folio);
      this.filterBar = new CustomerBillFilter(this.customerBills, {} );//JSON.parse(localStorage.customerBillRead || '{}')
      this.applyFilterBar();
      this.loaded = true;
    }); */
    this.readObjs = [];
    this.subs[0] = this.customerService.getCustomers().subscribe(customers => {
      console.log(`Got ${customers.length} customers.`)
      this.readObjs[0] = {};
      this.rowsRead[0] = customers.map(customer => {
        customer.id = customer.id$;
        this.readObjs[0][customer.id] = {...customer};
        return customer;
      });
      this.customers = [...customers] as any;
      this.customerId = this.customers.length ? this.customers[0].id : '';
      //console.log(this.customers, this.customerId);
      if(this.customerId) this.getCustomerBills();
      //else toast('Error obteniendo clientes.', 2000);
    });
    this.subs[1] = this.fiscalDataService.getAllFiscalDatas().subscribe(fiscalDatas => {
      this.readObjs[1] = {};
      this.allFiscalRows = fiscalDatas.filter(fiscalData => {
        fiscalData.name = fiscalData.businessName;
        this.readObjs[1][fiscalData.id] = {...fiscalData};
        if(fiscalData.customerId) return fiscalData;
      });
		});
    this.subs[2] = this.incomeService.getIncomes().subscribe(incomes => {
      this.incomes = incomes.reduce((obj, income) => {
        income.payMethod = this.incomeData.statusObjects[income.payMethod].name;
        obj[income.id] = income;
        return obj;
      }, {});
    });

	}

  ngOnInit() {
    /* window['executeOrder66'] = async () => {
      for(let i = 0; i < this.customerBills.length; i++){
        let bill: CustomerBillId = this.customerBills[i];
        await this.fsService.update(`${Globals.CUSTOMER_BILL_COLLECTION}/${bill.id}`, {customerId: bill.customerObj.id});
        console.log('Updated bill');
      }
    }; */
  }
  ngOnDestroy(){
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  getCustomerBills(){
    console.log('running getCustomerBills');
    if(!this.customerId){
      if(!confirm('¿Traer de todos los clientes? Puede tardar.')) return;
    }//return toast('Seleccione un cliente', 2000);
    this.loaded = false;
    if(this.subs[3]) this.subs[3].unsubscribe();
    //console.log(420, 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    this.subs[3] = this.service.getCustomerBills({
      customerId: this.customerId,
      onEmpty: () => { this.loaded = true; this.filterBar = new CustomerBillFilter([], {}); this.applyFilterBar(); },
      //only15days: !this.filterBar.dateIndex
      fetchRefs: false,
    }).subscribe(tempCustomerBills => {
      console.log(`Got ${tempCustomerBills.length} customerBills`);
      //console.log(69, tempCustomerBills);
      this.customerBills = tempCustomerBills.map(({cfdi:{currency='key0'}={}, status='key0', ...customerBill}: any) => {
        this.incomedBills[customerBill.id] = new IncomedBill({status, ...customerBill});
        customerBill.name = customerBill.folio;
        customerBill.statusName = this.billData.status[status];
        customerBill.uuid = customerBill.uuid || 'N.A.'
        customerBill.customerName = this.readObjs[0][customerBill.customerRef.id].name;
        customerBill.residue = this.incomedBills[customerBill.id].residue;
        customerBill.money_residue = this.money(customerBill.residue);
        customerBill.money_total = this.money(customerBill.totals.total)
        customerBill.currency = this.billData.currencySelect[currency].code;
        return customerBill;
      });
      this.filterBar = new CustomerBillFilter(this.customerBills, JSON.parse(this.filterBar.json) );
      this.applyFilterBar();
      this.loaded = true;
    });
  }
  /* async updateFields(){
    let bills = await this.fsService.colWithIds<CustomerBillId>(Globals.CUSTOMER_BILL_COLLECTION);
    console.log(bills.length);
    let hasCns: CustomerBillId[] = bills.filter((bill: CustomerBillId) => bill.creditNotes.length && bill.id);
    console.log(hasCns);
    if(confirm(`Updetear ${hasCns.length}?`)){
      for(let bill of hasCns){
        await this.service.updateByField({cnLength: bill.creditNotes.length}, bill.id);
      }
    }
  } */

  deleteCustomerBill(sid: string) {
    this.service.deleteCustomerBill(sid);
	}

	onCellClick(data: any): any {
		this.service.windowReplace('view', data.row.id);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.continueReadTo(0);
  }

  onShow(data: any){
    this.selectedCustomerBillId = data.row.id;
    this.openModalShow();
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.service.windowReplace('edit', `${data.row.id}/${data.row.fiscalDataRef.id}/${data.row.customerRef.id}`);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    if(this.incomedBills[this.selectedCustomerBillId].incomeIds.length) return toast('Para eliminar no debe haber ingresos asociados.');
		this.deleteCustomerBill(data.row.id);
  }

  ////////////////////////////////////////////////////////////////////FilterBar
  filterBar: CustomerBillFilter = new CustomerBillFilter([],{});
  applyFilterBar(){
    //localStorage.customerBillRead = this.filterBar.json;

    this.data = this.filterBar.filteredData;
    this.length = this.data.length;
    this.onChangeTable(this.config);
  }
  /* onChangeDateFilterBar(){
    if(this.filterBar.dateIndex && !this.receivedAll){
      this.loaded = false;
      this.subs[3].unsubscribe();
      this.subs[3] = this.service.getCustomerBills().subscribe(tempCustomerBills => {
        this.customerBills = tempCustomerBills.map(({cfdi:{currency='key0'}={}, status='key0', ...customerBill}: any) => {
          this.incomedBills[customerBill.id] = new IncomedBill({status, ...customerBill});
          customerBill.name = customerBill.folio;
          customerBill.statusName = this.billData.status[status];
          customerBill.uuid = customerBill.uuid || 'N.A.'
          customerBill.customerName = customerBill.customerObj.name;
          customerBill.residue = this.incomedBills[customerBill.id].residue;
          customerBill.money_residue = this.money(customerBill.residue);
          customerBill.money_total = this.money(customerBill.totals.total)
          customerBill.currency = this.billData.currencySelect[currency].code;
          return customerBill;
        });
        this.filterBar = new CustomerBillFilter(this.customerBills, JSON.parse(this.filterBar.json) );
        this.applyFilterBar();
        this.loaded = true;
      });
      this.receivedAll = true;
    }else{
      this.applyFilterBar();
    }
  } */
  ////////////////////////////////////////////////////////////////////FilterBar
  
  money = Utils.money;

  /////////////////////////////////////////////////////////////////////////////////////////////////////Incomes
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];

  incomes: any = {};
  incomedBills: {[id: string]: IncomedBill} = {};
  selectedCustomerBillId: string = '';

  incomeAmount(income: Income){
    return income.bills.find(bill => bill.customerBillId == this.selectedCustomerBillId).amount;
  }

  openModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////Incomes

	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(this.readValid) this.continueReadTo(this.currentReadIndex + 1);
  }
  continueReadTo(nextIndex){
    if(nextIndex == this.columnsRead.length){
      this.closeModalRead();
      this.service.windowReplace('add', `${this.selectedIds[1]}/${this.selectedIds[0]}`);
    }else{
      if(nextIndex == 1) this.rowsRead[nextIndex] = this.allFiscalRows.filter(fiscalRow => fiscalRow.customerId && fiscalRow.customerId == this.selectedIds[0]);
      this.currentReadIndex = nextIndex;
      this.r_data = this.rowsRead[nextIndex];
      this.r_config = this.r_configs[nextIndex];
      this.r_page = 1;
      this.r_onChangeTable(this.r_config);
      if(nextIndex == 0) this.openModalRead();
    }
  }
  goBackReadTo(prevIndex){
    if(prevIndex < 0){
      this.closeModalRead();
    }else{
      this.selectedIds[prevIndex + 1] = '';
      this.currentReadIndex = prevIndex;
      this.r_data = this.rowsRead[prevIndex];
      this.r_config = this.r_configs[prevIndex];
      this.r_onChangeTable(this.r_config);
    }
  }

  selectedIds: string [] = [];
  readObjs: any[] = [];
  subs: any[] = [];
  readPlaceholders = [ 'un cliente', 'su razón social' ]
  get readValid(){ return !!this.selectedIds[this.currentReadIndex] };
  currentReadIndex: number;
  allFiscalRows: any;
  rowsRead = [[], []];
  columnsRead = [
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [
      { title: 'Razón Social', name: 'name', sort: 'asc' },
      { title: 'RFC', name: 'rfc' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.clear();
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA


  onPdfExport(){

    console.log('UNMAPPED BILLS',this.rows);
    
    let processedRows: any[] = [];
    // let dateFilters = `Periodo desde ${this.initial} hasta ${this.final}`
      this.rows.map(({folio, customerName:cliente, date:fecha,  payDate:fecha_de_pago, statusName:estatus, money_total:total, money_residue:saldo, currency:moneda,
        ...customerBills}) => {
         total =  Utils.money(Utils.strToNumber(total))
         saldo = Utils.money(Utils.strToNumber(saldo))
 
       processedRows.push({folio, cliente, fecha, fecha_de_pago, estatus, total, saldo, moneda})
     });


    console.log('MAPPED BILLS', processedRows);

    PdfTemplates.Reports.CustomerBillsReport(processedRows)
    


  }

  /* log(){
    console.log(
      this.rows.length,
      this.rows.map(row => `${row.name}_${row.id}_${row.statusName}_${row.money_residue}`).join(',')
    )
  } */

}
